import { createTheme } from "@mui/material";

export const LightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: 'rgb(2, 41, 53)',
    },
    secondary: {
      main: 'rgb(22, 150, 116)',
    },
    background: {
      default: '#f5f5f5',
      paper: '#ffffff',
    },
    // Calendário
    calendario: {
      simuladoColor: "#343B9C",
      inspecaoColor: "#939393",
      treinamentoColor: "#E3BE2D",
      seminarioColor: "#349C7E",
      outraBarragemColor: "#f58122ff",

      simuladoCardColor: "rgb(68, 74, 153)",
      inspecaoCardColor: "rgb(163, 163, 163)",
      treinamentoCardColor: "rgb(226, 198, 85)",
      seminarioCardColor: "rgb(70, 160, 135)",
    },
    // Geometrias
    geometries: {
      rotaFuga: {
        color: '#E1DD0A',
        weight: 5,
        paintHovered: {
          color: '#8F8C08',
          weight: 10,
        }
      },
      rotaAlternativa: {
        color: "rgb(231, 138, 17)",
        weight: 5,
        paintHovered: {
          color: "rgb(238, 59, 9)",
          weight: 10,
        }
      },
      pontoEncontro: {
        color: "#31DE00",
        iconSize: 20,
      },
      acomodacao: {
        color: "rgb(37, 0, 124)",
        iconSize: 25,
        iconStr: 'PinDrop',
        bindTooltip: true,
      },
      uniSensivel: {
        color: "#f36a0c",
        iconSize: 25,
        iconStr: 'AddHomeWork',
        bindTooltip: true,
      },
      sirenes: {
        color: "#fff117",
        iconSize: 25,
        iconStr: 'Campaign',
        bindTooltip: true,
      },
      areaCoberturaSirene: {
        color: '#000000',
        fillColor: "#8546e7",
        weight: 1,
        opacity: 1,
        fillOpacity: 0.5,
        paintHovered: {
          opacity: 1,
          fillOpacity: 0.8
        }
      },
      geomBarragem: {
        color: '#FE9000',
      },
      polyZas: {
        color: '#e41a1c',
        fillColor: '#e41a1c',
        bindTooltip: true,
        weight: 2,
        opacity: 1,
        fillOpacity: 0,
        paintHovered: {
          opacity: 1,
          fillOpacity: 0.8
        }
      },
      polyZss: {
        color: '#01ffaf',
        fillColor: '#01ffaf',
        bindTooltip: true,
        weight: 2,
        opacity: 1,
        fillOpacity: 0,
        paintHovered: {
          opacity: 1,
          fillOpacity: 0.8
        }
      }
    }
  },
});